"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTokenCostsBody = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateTokenCostsBody = (0, validation_1.properties)({
    startDate: (0, validation_1.optional)((0, validation_1.text)()),
    endDate: (0, validation_1.optional)((0, validation_1.text)()),
});
//# sourceMappingURL=TokenCostsBody.js.map